import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {OphButtonModule} from 'src/app/shared/design/oph-button/oph-button.module';

@Component({
  selector: 'cb-dialog-header',
  standalone: true,
  template: `
    <div class="dialog-header">
      <img [src]="icon()" [alt]="title()" class="header-icon" />
      <div class="header-text">
        <div class="header-title">{{ title() }}</div>
        <div class="header-description">{{ description() }}</div>
      </div>
    </div>
  `,
  styles: `
    .dialog-header {
      display: flex;
      gap: 28px;
      align-items: center;
      margin-bottom: 30px;
    }

    .header-icon {
      width: 84px;
      height: 81px;
      object-fit: contain;
    }

    .header-text {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .header-title {
      font-family: 'Asap', sans-serif;
      font-size: 24px;
      font-weight: 600;
      line-height: 1;
      color: #5d4037;
    }

    .header-description {
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
      color: #4a443d;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbDialogHeaderComponent {
  icon = input.required<string>();
  title = input.required<string>();
  description = input.required<string>();
}

@Component({
  selector: 'cb-dialog-footer',
  standalone: true,
  imports: [OphButtonModule],
  template: `
    <div class="dialog-actions">
      <oph-button
        color="gray"
        appearance="outline"
        [style]="{'border-width': '1px', 'border-radius': '8px', width: '121px', height: '46px'}"
        (buttonClick)="cancel.emit()"
        >Cancel</oph-button
      >
      <oph-button
        [color]="saveColorHex() ? undefined : 'green'"
        [colorHex]="saveColorHex() ?? undefined"
        [colorHexText]="saveColorHexText() ?? undefined"
        [style]="{'border-radius': '8px', width: '159px', height: '46px'}"
        [loading]="loading()"
        [disabled]="loading() || saveDisabled()"
        (buttonClick)="save.emit()"
        >{{ saveLabel() }}</oph-button
      >
    </div>
  `,
  styles: `
    .dialog-actions {
      display: flex;
      gap: 11px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbDialogFooterComponent {
  loading = input(false);
  saveDisabled = input(false);
  saveLabel = input('Save');
  saveColorHex = input<string | undefined>(undefined);
  saveColorHexText = input<string | undefined>(undefined);

  cancel = output<void>();
  save = output<void>();
}
